import { render, staticRenderFns } from "./EnlightMockupImg.vue?vue&type=template&id=890b9c9e&"
import script from "./EnlightMockupImg.vue?vue&type=script&lang=js&"
export * from "./EnlightMockupImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports